import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { Label } from './styles';

const LabelWithHelp = ({ label, info }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
    <Label>{label}</Label>
    <Tooltip title={info} arrow>
      <IconButton size="small" tabIndex={-1}>
        <HelpOutlineIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  </div>
);

export default LabelWithHelp;